import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";

const routes : Array<RouteRecordRaw> = [
  {name: "login", path: '/login', component: () => import('@/views/Login.vue')},
  {name: "clients", path: '/clients', component: () => import('@/views/Clients.vue')},
  {name: "licenses", path: '/licenses', component: () => import('@/views/Licenses.vue')},
  {name: "licenseEdit", path: '/licenses/edit', component: () => import('@/views/LicenseEdit.vue')},
  {name: "assetEdit", path: '/asset/edit', component: () => import('@/views/AssetEdit.vue')},
  {name: "permissions", path: '/permissions', component: () => import('@/views/Permissions.vue')},
  {name: "permissionEdit", path: '/permissions/:id', component: () => import('@/views/PermissionEdit.vue')},
  {name: "permissionRules", path: '/permission-rules', component: () => import('@/views/PermissionRules.vue')},
  {name: "permissionRuleEdit", path: '/permission-rules/:id', component: () => import('@/views/PermissionRuleEdit.vue')},
  {name: "products", path: '/products', component: () => import('@/views/Products.vue')},
  {name: "productEdit", path: '/products/:id', component: () => import('@/views/ProductEdit.vue')},
  {name: "users", path: '/users', component: () => import('@/views/Users.vue')},
  {name: "userEdit", path: '/users/:id', component: () => import('@/views/UserEdit.vue')},
  {name: "productFamilies", path: '/product-families', component: () => import('@/views/ProductFamilies.vue')},
  {name: "productFamilyEdit", path: '/product-families/:id', component: () => import('@/views/ProductFamilyEdit.vue')},
  {name: "assetBatches", path: '/batches', component: () => import('@/views/AssetBatches.vue')},
  {name: "assetBatchDetails", path: '/batches/:id', component: () => import('@/views/AssetBatchDetails.vue')},
  {name: "assetBatchCreate", path: '/batches/create', component: () => import('@/views/AssetBatchCreate.vue')},
  {name: "underConstruction", path: '/under-construction', component: () => import('@/views/UnderConstruction.vue')},
  //{name: "testRender", path: '/testRender', component: () => import('@/components/LicenseForm.vue')},
];


const router : any = createRouter({
  history: createWebHistory(),
  routes,
});

export { router };